import {createWebHashHistory, createRouter} from "vue-router";
import GraphView from "@/src/views/graph/GraphView";
import OfflineView from "@/src/views/OfflineView";
import GraphNotFoundView from "@/src/views/GraphNotFoundView.vue";

import ChatBotAdminView from "@/src/views/chatbotAdmin/BaseView.vue";

export const ROUTE_NAMES = {
    HOME: "Home",
    OFFLINE: "Offline",
    STATUS: "Status",
    USER_MANAGEMENT: "UserManagement",
    SETTINGS: "Settings",
    CHATBOT_ADMIN: "ChatBotAdmin",
    PREFERENCES: "Preferences",
    GRAPH_NOT_FOUND: "GraphNotFound",
};

const routes = [
    {
        path: "/:graphId?",
        name: ROUTE_NAMES.HOME,
        component: HomeView,
        redirect: "/repo",
        children: [
            //these components are rendered inside a <router-view> nested in HomeView
            {
                path: "/graph",
                redirect: "/repo",
            },
            {
                path: "/repo/:spaceId?",
                name: ROUTE_NAMES.REPO,
                component: RepoView,
                props: true, // enable props to pass route params to the component
            },
            {
                path: "/graph/:graphId",
                name: ROUTE_NAMES.GRAPH,
                component: GraphView,
            },
            {
                path: "/graph-not-found",
                name: ROUTE_NAMES.GRAPH_NOT_FOUND,
                component: GraphNotFoundView,
            },
            // need to add a redirect for backwards compatibility from url /repo/:spaceId/:graphId to /graph/:graphId
            {
                path: "/repo/:spaceId/:graphId",
                redirect: to => {
                    return {
                        name: ROUTE_NAMES.GRAPH,
                        params: {graphId: to.params.graphId},
                    };
                },
            }
        ],
    },

    {
        path: "/chatbotadmin",
        name: ROUTE_NAMES.CHATBOT_ADMIN,
        component: ChatBotAdminView,
    },
    {
        path: "/login",
        name: ROUTE_NAMES.LOGIN,
        component: LoginView,
    },
    {
        path: "/offline",
        name: ROUTE_NAMES.OFFLINE,
        component: OfflineView,
        beforeEnter: (to, from, next) => {
            if (from.name === "Offline" || typeof from.name === "undefined") {
                next({name: "Home"});
            }
            next();
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to) => {
    return true;
});

export default router;
